// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23333333%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Inter", sans-serif;
}

.form-container {
  width: 100%;
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
  margin: 0 auto;
  background: #15141d;
  animation-name: dissolve;
  animation-timing-function: ease-out;
  animation-duration: 300ms;
}

.api-error-message {
  background-color: rgba(220, 53, 69, 0.1);
  border: 1px solid rgba(220, 53, 69, 0.3);
  border-radius: 8px;
  padding: 12px 16px;
  margin: 16px 0;
  text-align: center;
}

.api-error-message p {
  color: #dc3545;
  margin: 0;
  font-weight: 500;
}

.api-success-message {
  background-color: rgba(40, 167, 69, 0.1);
  border: 1px solid rgba(40, 167, 69, 0.3);
  border-radius: 8px;
  padding: 12px 16px;
  margin: 16px 0;
  text-align: center;
}

.api-success-message p {
  color: #28a745;
  margin: 0;
  font-weight: 500;
}


.form {
  background: #15141d;
}
.main-container {
  width: 935px;
  border: 3px solid rgba(245, 238, 238, 0.035);
  margin: 100px auto 0;
  padding: 40px;
  border-radius: 16px;
  height: 100%;
  background-color: rgba(28, 27, 38, 1);
}

.form-info h3 {
  font-family: Eczar;
  font-size: 30px;
  font-weight: 500;
  line-height: 40px;
  letter-spacing: 0em;
  justify-content: flex-start;
}

.forminput-container {
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    );
 
}

.formInput,
.form-info h3,
.form-text h4,
.form-text p {
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    );
}
.form-inputs {
  font-size: 14px;
  font-family: "Inter";
}
.form-inputs input,
.form-inputs select {
  font-family: Inter;
  padding: 1rem;
  background-color: white;
  color: #000000;
  font-weight: 400;
  font-size: 14px;
  line-height: 32px;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: none;
  border-radius: 8px;
  box-sizing: border-box;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: .65em auto;
  padding-right: 2.5rem;
}

.form-inputs label {
  display: inline-block;
  margin-top: 28px;
  margin-bottom: 10px;
  color: #fff;
  font-weight: 400;
  font-family: "Inter";
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    );
}

.form-inputs p {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
  margin-bottom: 0;
  font-weight: 500;
}

.form-text h3 {
  color: #fffbf7;
  margin-top: 24px;
  font-family: Eczar;
  font-size: 24px;
  font-weight: 500;
  line-height: 40px;
}

.form-text p {
  font-family: "Inter";
  color: #b3b3b3;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 12px;
  line-height: 28px;
}

.btn-container button {
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/FormInput.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,4CAA4C;EAC5C,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE;;;;;KAKG;;AAEL;;AAEA;;;;EAIE;;;;;KAKG;AACL;AACA;EACE,eAAe;EACf,oBAAoB;AACtB;AACA;;EAEE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EAGtB,gBAAgB;EAChB,yDAAof;EACpf,4BAA4B;EAC5B,sCAAsC;EACtC,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB;;;;;KAKG;AACL;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: \"Inter\", sans-serif;\n}\n\n.form-container {\n  width: 100%;\n  overflow-y: scroll;\n  scroll-snap-type: y mandatory;\n  margin: 0 auto;\n  background: #15141d;\n  animation-name: dissolve;\n  animation-timing-function: ease-out;\n  animation-duration: 300ms;\n}\n\n.api-error-message {\n  background-color: rgba(220, 53, 69, 0.1);\n  border: 1px solid rgba(220, 53, 69, 0.3);\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin: 16px 0;\n  text-align: center;\n}\n\n.api-error-message p {\n  color: #dc3545;\n  margin: 0;\n  font-weight: 500;\n}\n\n.api-success-message {\n  background-color: rgba(40, 167, 69, 0.1);\n  border: 1px solid rgba(40, 167, 69, 0.3);\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin: 16px 0;\n  text-align: center;\n}\n\n.api-success-message p {\n  color: #28a745;\n  margin: 0;\n  font-weight: 500;\n}\n\n\n.form {\n  background: #15141d;\n}\n.main-container {\n  width: 935px;\n  border: 3px solid rgba(245, 238, 238, 0.035);\n  margin: 100px auto 0;\n  padding: 40px;\n  border-radius: 16px;\n  height: 100%;\n  background-color: rgba(28, 27, 38, 1);\n}\n\n.form-info h3 {\n  font-family: Eczar;\n  font-size: 30px;\n  font-weight: 500;\n  line-height: 40px;\n  letter-spacing: 0em;\n  justify-content: flex-start;\n}\n\n.forminput-container {\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n \n}\n\n.formInput,\n.form-info h3,\n.form-text h4,\n.form-text p {\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n}\n.form-inputs {\n  font-size: 14px;\n  font-family: \"Inter\";\n}\n.form-inputs input,\n.form-inputs select {\n  font-family: Inter;\n  padding: 1rem;\n  background-color: white;\n  color: #000000;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 32px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  border: none;\n  border-radius: 8px;\n  box-sizing: border-box;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23333333%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');\n  background-repeat: no-repeat;\n  background-position: right 1rem center;\n  background-size: .65em auto;\n  padding-right: 2.5rem;\n}\n\n.form-inputs label {\n  display: inline-block;\n  margin-top: 28px;\n  margin-bottom: 10px;\n  color: #fff;\n  font-weight: 400;\n  font-family: \"Inter\";\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n}\n\n.form-inputs p {\n  color: #dc3545;\n  font-size: 12px;\n  margin-top: 4px;\n  margin-bottom: 0;\n  font-weight: 500;\n}\n\n.form-text h3 {\n  color: #fffbf7;\n  margin-top: 24px;\n  font-family: Eczar;\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 40px;\n}\n\n.form-text p {\n  font-family: \"Inter\";\n  color: #b3b3b3;\n  font-size: 14px;\n  font-weight: 400;\n  margin-bottom: 12px;\n  line-height: 28px;\n}\n\n.btn-container button {\n  color: #000;\n  text-align: center;\n  font-family: Inter;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
